export function ConfidenceBar({ value }: { value: number }) {
  const pct = Math.max(0, Math.min(1, value));
  const tone =
    pct >= 0.85 ? "bg-emerald-500" : pct >= 0.65 ? "bg-amber-500" : "bg-slate-300";
  return (
    <div className="flex items-center gap-2">
      <div className="h-1.5 w-24 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full ${tone}`} style={{ width: `${pct * 100}%` }} />
      </div>
      <span className="text-xs text-slate-600 tabular-nums">
        {(pct * 100).toFixed(0)}%
      </span>
    </div>
  );
}
